export default "__VITE_ASSET__BGbgkmfy__"